<template>
	<page>
		<module>
			<view-list work-type="23" ref="view" selector :view-config="auth('b_performance_statistics_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="工程师姓名">
							<c-input name="engineer_name" maxlength="50" placeholder="请输入"></c-input>
						</m-search-item>
						<m-search-item label="所属网点">
							<c-select ref="outletSelect" name="outlet_id" placeholder="请选择" async @search="searchOutlet"></c-select>
						</m-search-item>
						<m-search-item label="统计周期" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date" format="yyyy-MM-dd"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

                <template #operate>
                    <c-button v-if="auth('b_performance_statistics_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_performance_statistics_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>


                <template #engineer_name="{data}">
					<c-link @click="openPerformanceDetail(data)">{{ data.engineer_name }}</c-link>
				</template>

				<template #total_work_hours="{data}">
					<c-link @click="openPerformanceDetail(data)">{{ data.total_work_hours }}&nbsp;h</c-link>
				</template>
				<template #total_work_hours_summed="{total}">
					<span>{{total.toFixed(2)}} h</span>
				</template>
				<template #total_work_hours_tip>
					<c-tooltip>
						<template #tip>
							<p>搜索时间内，工程师的已完工工单打卡工时：</p>
							<p>1、到达打卡时间与出发打卡时间之间的时间差值：</p>
							<p>2、下班打卡时间与上班打卡时间之间的时间差值（如果不存在上班或下班打卡，则默认工作8小时）：</p>
						</template>
					</c-tooltip>
				</template>

				<template #clock_work_hours="{data}">
					{{ data.clock_work_hours }}&nbsp;h
				</template>
				<template #clock_work_hours_summed="{total}">
					<span>{{total.toFixed(2)}} h</span>
				</template>
				<template #clock_work_hours_tip>
					<c-tooltip>
						<template #tip>
							<p>搜索时间内，根据工程师的考勤打卡记录，按打卡日期汇总的工时，工时包含以下两部分：</p>
							<p>1、在途工时：出发打卡时间与到达打卡时间之间的时间差值；</p>
							<p>2、上下班工时：下班打卡时间与上班打卡时间之间的时间差值。</p>
						</template>
					</c-tooltip>
				</template>

				<template #travel_km="{data}">
					{{ fmtKm(data.travel_km) }}
				</template>
				<template #travel_km_tip>
					<c-tooltip>
						<template #tip>
							<p>搜索时间内，根据工程师参与的工单，出发网点与客户服务地址的（驾车）距离</p>
						</template>
					</c-tooltip>
				</template>

				<template #install_product_count="{data}">
					{{ data.install_product_count != null ? data.install_product_count : '-' }}
				</template>
				<template #install_product_count_summed="{total}">
					<span>{{total.toFixed(2)}}</span>
				</template>
				<template #install_product_count_tip>
					<c-tooltip align="end">
						<template #tip>
							搜索时间内， 确认完工时，填写的安装数量
						</template>
					</c-tooltip>
				</template>

				<template #avg_install_product_work_hours="{data}">
					<c-link @click="openInstallProductDetail(data)">{{ fmtHour(data.avg_install_product_work_hours) }}</c-link>
				</template>
				<template #avg_install_product_work_hours_tip>
					<c-tooltip align="end">
						<template #tip>
							搜索时间内，工程师确认完工时填写的工时数据均值
						</template>
					</c-tooltip>
				</template>

				<template #completed_order_count="{data}">
					{{ data.completed_order_count != null ? data.completed_order_count+'单' : '-' }}
				</template>
				<template #completed_order_count_tip>
					<c-tooltip align="end">
						<template #tip>
							搜索时间内，工程师参与且已完工的工单数
						</template>
					</c-tooltip>
				</template>

				<template #avg_completion_days="{data}">
					{{ fmtDay(data.avg_completion_days) }}
				</template>
				<template #avg_completion_days_tip>
					<c-tooltip align="end">
						<template #tip>
							搜索时间内，工程师参与的工单，使用结束时间与开始时间的差值取均值
						</template>
					</c-tooltip>
				</template>

				<template #ontime_precent="{data}">
					{{data.ontime_precent}}&nbsp;%
				</template>
				<template #ontime_precent_tip>
					<c-tooltip align="end">
						<template #tip>
							工程师实际完工时间在计划派单结束时间之前，则算作按时完成
						</template>
					</c-tooltip>
				</template>

				<template #avg_customer_score="{data}">
					{{ fmtScore(data.avg_customer_score) }}
				</template>
				<template #avg_customer_score_tip>
					<c-tooltip align="end">
						<template #tip>
							搜索时间内，工程师参与的工单，获得的客户评分取均值
						</template>
					</c-tooltip>
				</template>

				<template #leave_days="{data}">
					{{ data.leave_days != null && data.leave_days !== '' ? data.leave_days : '-' }}&nbsp;天
				</template>
				<template #leave_days_summed="{total}">
					<span>{{total.toFixed(2)}}</span>
				</template>
				<template #leave_days_tip>
					<c-tooltip align="end">
						<template #tip>
							搜索时间内的请假天数
						</template>
					</c-tooltip>
				</template>

				<template #personal_reimbursement_money="{data}">
					￥{{ data.personal_reimbursement_money != null && data.personal_reimbursement_money !== '' ? data.personal_reimbursement_money.toFixed(2) : '-' }}
				</template>
				<template #personal_reimbursement_money_summed="{total}">
					<span>{{total.toFixed(2)}}</span>
				</template>
				<template #personal_reimbursement_money_tip>
					<c-tooltip align="end">
						<template #tip>
							搜索时间内，当前工程师参与的所有工单的的"个人报销费用"总和
						</template>
					</c-tooltip>
				</template>

				<template #avg_public_reimbursement_money="{data}">
					￥{{ data.avg_public_reimbursement_money != null && data.avg_public_reimbursement_money !== '' ? data.avg_public_reimbursement_money.toFixed(2) : '-' }}
				</template>
				<template #avg_public_reimbursement_money_summed="{total}">
					<span>{{total.toFixed(2)}}</span>
				</template>
				<template #avg_public_reimbursement_money_tip>
					<c-tooltip align="end">
						<template #tip>
							搜索时间内，当前工程师参与的所有工单，工单"公共报销费用"分摊到当前工程师的分摊费用总和
						</template>
					</c-tooltip>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
export default {
	name: 'EngineerPerformanceList',

	data() {
		return {
			defaultSearchData: this.buildDefaultRange()
		};
	},

	methods: {
		buildDefaultRange() {
			const now = new Date();
			const y = now.getFullYear();
			const m = now.getMonth() + 1;
			const pad = (n) => String(n).padStart(2, '0');
			const last = new Date(y, m, 0).getDate();
			return {
				start_date: `${y}-${pad(m)}-01`,
				end_date: `${y}-${pad(m)}-${pad(last)}`
			};
		},

		searchOutlet(keyword, resolve) {
			this.request({
				url: '/system/options',
				data: {
					options_code: 'AFTERSALE_OUTLET',
					keyword: keyword || ''
				},
				success: (data) => {
					resolve(
						(data || []).map((item) => ({
							name: item.data.outlet_name,
							value: item.data.id,
							data: item.data
						}))
					);
				}
			});
		},

		fmtHour(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			return `${v}h`;
		},
		fmtKm(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			return `${v}km`;
		},
		fmtDay(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			return `${v}天`;
		},
		fmtScore(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			const n = parseFloat(v);
			if (Number.isNaN(n) || n <= 0) {
				return '-';
			}
			return n.toFixed(2);
		},

		openPerformanceDetail(row) {
			const cnt =
				row && row.completed_order_count != null && row.completed_order_count !== ''
					? Number(row.completed_order_count)
					: 0;
			const q = Object.assign({}, this.$refs.search.get(), { user_id: row.user_id });
			delete q.engineer_name;
			this.globalDialog('engineerPerformanceDetail', {
				data: {
					engineer_name: row.engineer_name,
					completed_order_count: Number.isNaN(cnt) ? 0 : cnt,
					query: q
				}
			});
		},

		openInstallProductDetail(row) {
			const q = Object.assign({}, this.$refs.search.get(), { user_id: row.user_id });
			delete q.engineer_name;
			this.globalDialog('engineerPerformanceProductDetail', {
				data: {
					engineer_name: row.engineer_name,
					query: q
				}
			});
		}
	}
};
</script>

<style lang="stylus" scoped>
</style>
